import { useMemo, useState } from 'react';
import { format } from 'date-fns';
import { fetchEmployeeBreakdown } from '../../api';
import useNodeRequest from '../nodes/useNodeRequest';
import { defaultGranularity, resolveActiveForm, scoredForms, sortEmployees } from './callTypesModel';

/**
 * Разбор по сотрудникам для одного среза. Шаг и форма чек-листа живут здесь, а не в графике:
 * ими пользуются и график, и карточка качества, и выбранная форма у них должна быть одна.
 */
const useEmployeeBreakdown = ({ dateRange, callType, nodeFilter, denominatorFilter, enabled = true }) => {
  const [granularity, setGranularity] = useState(() => defaultGranularity(dateRange));
  const [selectedFormCode, setSelectedFormCode] = useState(null);

  const params = useMemo(
    () => ({
      date_from: format(dateRange.from, 'yyyy-MM-dd'),
      date_to: format(dateRange.to, 'yyyy-MM-dd'),
      call_type: callType === 'all' ? undefined : callType,
      node_filter: nodeFilter,
      denominator_node_filter: denominatorFilter,
      granularity
    }),
    [dateRange, callType, nodeFilter, denominatorFilter, granularity]
  );

  const { data, isLoading, error } = useNodeRequest({
    fetcher: fetchEmployeeBreakdown,
    params,
    errorText: 'Не удалось загрузить разбор по сотрудникам.',
    enabled,
    // За год запрос считается секунды, а данные за прошлые периоды не меняются: опрашивать незачем.
    poll: false
  });

  const employees = useMemo(() => sortEmployees(data?.employees), [data]);
  const forms = useMemo(() => scoredForms(data), [data]);

  return {
    employees,
    forms,
    formCode: resolveActiveForm(forms, selectedFormCode),
    onFormChange: setSelectedFormCode,
    granularity,
    onGranularityChange: setGranularity,
    lowSampleThreshold: data?.lowSampleThreshold ?? 0,
    // До первого ответа данных ещё нет: без этого на миг показалось бы «нет звонков».
    isLoading: isLoading || (!data && !error),
    error
  };
};

export default useEmployeeBreakdown;
